<template lang="pug">
  include ../tool/CommonList.pug

</template>


<script>
  import {Model, EditDialog} from "./imports.js"

  import CommonList from "../tool/CommonList.js"

  export default {
    extends: CommonList,
    components: {
      EditDialog//, ConfirmDelete
    },
    data: () => ({
    }),
    computed: {
    },
    watch: {
    }, 
    methods: {
      loadModel: function() {
        this.model = new Model()
      },

      isViewAllowed() {
        return false
      },
      isDeleteAllowed() {
        return true
      },
      setup () {
        //console.log("parent_id : "  + this.parent_id)
        this.hidesearch = true
 
        this.headers = [
          {align: "start", width: "10", text: this.model.content + '.' + 'label', value: 'label', sortable: false},
          {align: "start", width: "10", text: this.model.content + '.' + 'description', value: 'description', sortable: false},
          {align: "end", width: "10", text: this.model.content + '.' + 'value', value: 'value', sortable: false},
  
          {align: "center", width: "60", text: 'common.created_date', value: 'created_date', sortable: false},
          {align: "center", width: "30", text: 'common.actions', value: 'name', sortable: false }
          
        ],

        this.columns = [
          {class: "text-left", value: 'label'},
          {class: "text-left", value: 'description'},
          {class: "text-right", value: 'value'},

          {class: "text-right", value: 'created_date', format: this.formatDatetime},
        ]
      },
    },

  }


</script>
